function getSafra4(){
    var $select = $('#selecsafra4');
    var safra = $select.val();

    return safra;
}

function gaugeProd(ling){

    var safra = getSafra4();

    var urlJSON = "/api/dadosprodutividade/" + safra + "?size=1000";

    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
        
            area = json.map(function(item) {
                return item.area;
            });

            quantidade = json.map(function(item) {
                return item.quantidade;
            });

            var texto;
            if(ling === 'pt'){
                texto = "Produtividade: ";
            }
            else if(ling === 'es'){
                texto = "Productividad: ";
            }
            else{
                texto = "Productivity: ";
            }

            var opts = {
                angle: 0.15, // The span of the gauge arc
                lineWidth: 0.44, // The line thickness
                radiusScale: 1, // Relative radius
                staticLabels: {
                    font: "15px sans-serif",  // Specifies font
                    labels: [0, 50, 70, 120],  // Print labels at these values
                    color: "#000000",  // Optional: Label text color
                    fractionDigits: 0  // Optional: Numerical precision. 0=round off.
                },   
                pointer: {
                    length: 0.6, // // Relative to gauge radius
                    strokeWidth: 0.035, // The thickness
                    color: '#000000' // Fill color
                },
                staticZones: [
                    {strokeStyle: "#F03E3E", min: 0, max: 50}, // Red from 100 to 130
                    {strokeStyle: "#FFDD00", min: 50, max: 70}, // Yellow
                    {strokeStyle: "#30B32D", min: 70, max: 120}, // Green
                ],
                limitMax: false,     // If false, max value increases automatically if value > maxValue
                limitMin: false,     // If true, the min value of the gauge will be fixed
                colorStart: '#6FADCF',   // Colors
                colorStop: '#8FC0DA',    // just experiment with them
                strokeColor: '#E0E0E0',  // to see which ones work best for you
                generateGradient: true,
                highDpiSupport: true,     // High resolution support
                //percentColors: [[0.0, "#ff0000" ], [0.50, "#f9c802"], [1.0, "#00ff00"]]
            };
            var target = document.getElementById('grafprodexec'); // your canvas element
            var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
            gauge.maxValue = 120; // set max gauge value
            gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
            gauge.animationSpeed = 32; // set animation speed (32 is default value)
            gauge.set(quantidade[0]/area[0]); // set actual value
            $("#prodexecvalor").html(texto + quantidade[0]/area[0]);
        }
    });
}

function gaugeProdPlan(ling){

    var safra = getSafra4();

    var urlJSON = "/api/dadosprodutividadeplan/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            area = json.map(function(item) {
                return item.area;
            });

            quantidade = json.map(function(item) {
                return item.quantidade;
            });

            var texto;
            if(ling === 'pt'){
                texto = "Produtividade: ";
            }
            else if(ling === 'es'){
                texto = "Productividad: ";
            }
            else{
                texto = "Productivity: ";
            }

            var opts = {
                angle: 0.15, // The span of the gauge arc
                lineWidth: 0.44, // The line thickness
                radiusScale: 1, // Relative radius
                staticLabels: {
                    font: "15px sans-serif",  // Specifies font
                    labels: [0, 50, 70, 120],  // Print labels at these values
                    color: "#000000",  // Optional: Label text color
                    fractionDigits: 0  // Optional: Numerical precision. 0=round off.
                },   
                pointer: {
                    length: 0.6, // // Relative to gauge radius
                    strokeWidth: 0.035, // The thickness
                    color: '#000000' // Fill color
                },
                staticZones: [
                    {strokeStyle: "#F03E3E", min: 0, max: 50}, // Red from 100 to 130
                    {strokeStyle: "#FFDD00", min: 50, max: 70}, // Yellow
                    {strokeStyle: "#30B32D", min: 70, max: 120}, // Green
                ],
                limitMax: false,     // If false, max value increases automatically if value > maxValue
                limitMin: false,     // If true, the min value of the gauge will be fixed
                colorStart: '#6FADCF',   // Colors
                colorStop: '#8FC0DA',    // just experiment with them
                strokeColor: '#E0E0E0',  // to see which ones work best for you
                generateGradient: true,
                highDpiSupport: true,     // High resolution support
                //percentColors: [[0.0, "#ff0000" ], [0.50, "#f9c802"], [1.0, "#00ff00"]]
            };
            var target = document.getElementById('grafprodplan'); // your canvas element
            var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
            gauge.maxValue = 120; // set max gauge value
            gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
            gauge.animationSpeed = 32; // set animation speed (32 is default value)
            gauge.set(quantidade[0]/area[0]); // set actual value
            $("#prodplanvalor").html(texto + quantidade[0]/area[0]);
        }
    });

}

function gaugeRentPlan(ling){

    var safra = getSafra4();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']

    var urlJSON1 = "/api/servicosetapa/" + safra + "?size=1000";
    var urlJSON2 = "/api/aquisicaosplan/valor/" + safra + "?size=1000";

    $.ajax({
        url:  urlJSON1,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {

        $.ajax({
            url:  urlJSON2,
            type: 'GET',
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
            },
            success: function(json2) {

                fluxo = json.map(function(item) {
                    return item.fluxo;
                });

                valor = json.map(function(item) {
                    return item.valorservico;
                });

                tipoetapa = json.map(function(item) {
                    return item.tipoetapa;
                });
                
                valoraq  = json2.map(function(item) {
                    return item.total;
                });

                var tamanho = tipoetapa.length;
                var total_desp = valoraq[0]; var total_rec = 0;

                for(i=0; i<tamanho; i++){
                    if(etapasplan.indexOf(tipoetapa[i])==-1) continue;

                    if(fluxo[i]==='despesa') total_desp = total_desp + valor[i];
                    else total_rec = total_rec + valor[i];
                }

                var rent = (100.0*total_rec)/total_desp -100.0;
                console.log('>'+total_rec+'>>'+total_desp+'>>>'+rent);

                var texto;
                if(ling === 'pt'){
                    texto = "Rentabilidade: ";
                }
                else if(ling === 'es'){
                    texto = "Rendimiento: ";
                }
                else{
                    texto = "Profitability: ";
                }

                var opts = {
                    angle: 0.15, // The span of the gauge arc
                    lineWidth: 0.44, // The line thickness
                    radiusScale: 1, // Relative radius
                    staticLabels: {
                        font: "15px sans-serif",  // Specifies font
                        labels: [-100, 0, 20, 100],  // Print labels at these values
                        color: "#000000",  // Optional: Label text color
                        fractionDigits: 0  // Optional: Numerical precision. 0=round off.
                    },   
                    pointer: {
                        length: 0.6, // // Relative to gauge radius
                        strokeWidth: 0.035, // The thickness
                        color: '#000000' // Fill color
                    },
                    staticZones: [
                        {strokeStyle: "#F03E3E", min: -100, max: 0}, // Red from 100 to 130
                        {strokeStyle: "#FFDD00", min: 0, max: 20}, // Yellow
                        {strokeStyle: "#30B32D", min: 20, max: 100}, // Green
                    ],
                    limitMax: false,     // If false, max value increases automatically if value > maxValue
                    limitMin: false,     // If true, the min value of the gauge will be fixed
                    colorStart: '#6FADCF',   // Colors
                    colorStop: '#8FC0DA',    // just experiment with them
                    strokeColor: '#E0E0E0',  // to see which ones work best for you
                    generateGradient: true,
                    highDpiSupport: true,     // High resolution support
                    //percentColors: [[0.0, "#ff0000" ], [0.50, "#f9c802"], [1.0, "#00ff00"]]
                };
                var target = document.getElementById('grafrentplan'); // your canvas element
                var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
                gauge.maxValue = 100; // set max gauge value
                gauge.setMinValue(-100);  // Prefer setter over gauge.minValue = 0
                gauge.animationSpeed = 32; // set animation speed (32 is default value)
                gauge.set(rent); // set actual value
                $("#rentplanvalor").html(texto + Math.round(rent) + "%");
            }
        });
    }
    });

}


function gaugeRent(ling){

    var safra = getSafra4();
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']


    var urlJSON1 = "/api/servicosetapa/" + safra + "?size=1000";
    var urlJSON2 = "/api/aquisicaosplan/valor/" + safra + "?size=1000";

    $.ajax({
        url:  urlJSON1,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {

        $.ajax({
            url:  urlJSON2,
            type: 'GET',
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
            },
            success: function(json2) {

                fluxo = json.map(function(item) {
                    return item.fluxo;
                });

                valor = json.map(function(item) {
                    return item.valorservico;
                });

                tipoetapa = json.map(function(item) {
                    return item.tipoetapa;
                });
                
                valoraq  = json2.map(function(item) {
                    return item.total;
                });

                var tamanho = tipoetapa.length;
                var total_desp = valoraq[0]; var total_rec = 0;

                for(i=0; i<tamanho; i++){
                    if(etapas.indexOf(tipoetapa[i])==-1) continue;

                    if(fluxo[i]==='despesa') total_desp = total_desp + valor[i];
                    else total_rec = total_rec + valor[i];
                }

                var rent = (100.0*total_rec)/total_desp -100.0;
                console.log('>'+total_rec+'>>'+total_desp+'>>>'+rent);

                var texto;
                if(ling === 'pt'){
                    texto = "Rentabilidade: ";
                }
                else if(ling === 'es'){
                    texto = "Rendimiento: ";
                }
                else{
                    texto = "Profitability: ";
                }

                var opts = {
                    angle: 0.15, // The span of the gauge arc
                    lineWidth: 0.44, // The line thickness
                    radiusScale: 1, // Relative radius
                    staticLabels: {
                        font: "15px sans-serif",  // Specifies font
                        labels: [-100, 0, 20, 100],  // Print labels at these values
                        color: "#000000",  // Optional: Label text color
                        fractionDigits: 0  // Optional: Numerical precision. 0=round off.
                    },   
                    pointer: {
                        length: 0.6, // // Relative to gauge radius
                        strokeWidth: 0.035, // The thickness
                        color: '#000000' // Fill color
                    },
                    staticZones: [
                        {strokeStyle: "#F03E3E", min: -100, max: 0}, // Red from 100 to 130
                        {strokeStyle: "#FFDD00", min: 0, max: 20}, // Yellow
                        {strokeStyle: "#30B32D", min: 20, max: 100}, // Green
                    ],
                    limitMax: false,     // If false, max value increases automatically if value > maxValue
                    limitMin: false,     // If true, the min value of the gauge will be fixed
                    colorStart: '#6FADCF',   // Colors
                    colorStop: '#8FC0DA',    // just experiment with them
                    strokeColor: '#E0E0E0',  // to see which ones work best for you
                    generateGradient: true,
                    highDpiSupport: true,     // High resolution support
                    //percentColors: [[0.0, "#ff0000" ], [0.50, "#f9c802"], [1.0, "#00ff00"]]
                };
                var target = document.getElementById('grafrentexec'); // your canvas element
                var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
                gauge.maxValue = 100; // set max gauge value
                gauge.setMinValue(-100);  // Prefer setter over gauge.minValue = 0
                gauge.animationSpeed = 32; // set animation speed (32 is default value)
                gauge.set(rent); // set actual value
                $("#rentexecvalor").html(texto + Math.round(rent) + "%");
            }
        });
    }
    });
}

function linguagemind(){

    var urlJSON = '/api/account/';

    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            var linguagem = json.langKey;

            if(linguagem==="pt-br"){
                montaRelatorioInd('pt');
            }
            else if(linguagem==="en"){
                montaRelatorioInd('en');
            }
            else{
                montaRelatorioInd('es');
            }
        }
    });
}

function montaRelatorioInd(ling){
    if(ling === 'pt'){
        $('#tituloplanrent').html("Rentabilidade Esperada");
        $('#tituloexecrent').html("Rentabilidade");
        $('#tituloplanprod').html("Produtividade Esperada");
        $('#tituloexecprod').html("Produtividade");
    }
    else if(ling === 'es'){
        $('#tituloplanrent').html("Rentabilidad Esperada");
        $('#tituloexecrent').html("Rentabilidad");
        $('#tituloplanprod').html("Productividad Esperada");
        $('#tituloexecprod').html("Productividad");
    }
    else{
        $('#tituloplanrent').html("Expected profitability");
        $('#tituloexecrent').html("Profitability");
        $('#tituloplanprod').html("Expected productivity ");
        $('#tituloexecprod').html("Productivity");       
    }
        
    gaugeProd(ling);
    gaugeRent(ling);
    gaugeProdPlan(ling);
    gaugeRentPlan(ling);



}